export const DEFAULT_OPTIONS = {
  disabled: false,
  visible: true
};
